"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useImageService = void 0;
const react_1 = require("react");
const constants_1 = require("../lib/constants");
const ImageServiceProvider_1 = require("../providers/ImageServiceProvider");
const buildImageUrl_1 = require("../components/SizedImage/buildImageUrl");
const useImageService = () => {
    const context = (0, react_1.useContext)(ImageServiceProvider_1.ImageServiceContext);
    if (!context) {
        throw new Error('useImageService must be used within an ImageServiceProvider');
    }
    const { updateConfig, config } = context;
    const [canUseWebp, setCanUseWebp] = (0, react_1.useState)(false);
    const [devicePixelRatio, setDevicePixelRatio] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        // Check if we're in a browser environment
        if (typeof window === 'undefined' || typeof Image === 'undefined') {
            setCanUseWebp(false);
            return;
        }
        try {
            const img = new Image();
            img.onload = function () {
                const result = img.width > 0 && img.height > 0;
                setCanUseWebp(result);
            };
            img.onerror = function () {
                setCanUseWebp(false);
            };
            img.src = constants_1.LOSSLESS_IMAGE;
            if (typeof window.devicePixelRatio === 'number') {
                setDevicePixelRatio(window.devicePixelRatio.toString());
            }
            // Cleanup function to prevent memory leaks
            return () => {
                img.onload = null;
                img.onerror = null;
            };
        }
        catch (error) {
            // Handle Image constructor errors gracefully
            setCanUseWebp(false);
            return undefined; // No cleanup needed if image creation failed
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (updateConfig) {
            const updates = {};
            // Only update webpEnabled if it wasn't explicitly set to true
            if (config.webpEnabled !== true) {
                updates.webpEnabled = canUseWebp;
            }
            // Only update devicePixelRatio if we have a value
            if (devicePixelRatio) {
                updates.devicePixelRatio = parseFloat(devicePixelRatio);
            }
            if (Object.keys(updates).length > 0) {
                updateConfig(updates);
            }
        }
    }, [canUseWebp, devicePixelRatio, updateConfig, config.webpEnabled]);
    // Attach URL build function for building image URLs
    const getImageUrl = (src, options) => {
        var _a;
        return (0, buildImageUrl_1.buildImageUrl)({
            serviceUrl: config.serviceUrl,
            src,
            width: options === null || options === void 0 ? void 0 : options.width,
            height: options === null || options === void 0 ? void 0 : options.height,
            isWebpSupported: config.webpEnabled || false,
            devicePixelRatio: (_a = config.devicePixelRatio) === null || _a === void 0 ? void 0 : _a.toString()
        });
    };
    return Object.assign(Object.assign({}, context), { getImageUrl });
};
exports.useImageService = useImageService;
//# sourceMappingURL=useImageServiceHook.js.map